// Configuration des textes multilingues pour les chambres de l'hu00f4tel

export const roomTexts = {
  fr: {
    pageTitle: 'Nos Chambres',
    pricePrefix: 'À partir de',
    taxInfo: '*plus {taxe}€ de taxe de séjour par personne',
    rooms: [
      {
        id: 'single',
        title: 'Chambres Single',
        description: 'Parfaite pour les voyageurs en solo, notre chambre Single offre un espace cosy et chaleureux avec tout le confort moderne. Idéale pour se ressourcer après une journée de découverte en Normandie.',
        features: ['Télévision', 'WiFi gratuit', 'Salle de bain privative']
      },
      {
        id: 'double',
        title: 'Chambres Double',
        description: 'Profitez d\'un séjour romantique dans notre chambre Double, alliant confort et élégance. Un cocon parfait pour vous reposer après avoir exploré les merveilles de la Normandie.',
        features: ['Télévision', 'WiFi gratuit', 'Salle de bain privative']
      },
      {
        id: 'design',
        title: 'Chambres Design',
        description: 'Trois chambres "Design", dont une aux normes handicapés, sont à votre disposition pour plus de confort et d\'élégance. Ces chambres ont reçu un prix d\'architecture décerné par le CAUE (Conseil d\'Architecture d\'Urbanisme et d\'Environnement).',
        pmrNote: '2 chambres accessibles PMR disponibles. Merci de le préciser lors de votre réservation.',
        features: ['Télévision', 'WiFi gratuit', 'Salle de bain privative', 'Design primé', 'Accessibilité']
      },
      {
        id: 'family4',
        title: 'Chambres Familiales (4 personnes)',
        description: 'Vivez une expérience familiale inoubliable dans nos chambres spacieuses pouvant accueillir jusqu\'à 4 personnes. Tout le confort nécessaire pour que chaque membre de la famille se sente comme à la maison.',
        features: ['Télévision', 'WiFi gratuit', 'Salle de bain privative', 'Espace familial']
      },
      {
        id: 'family5',
        title: 'Chambres Familiales (5 personnes)',
        description: 'Notre chambre familiale la plus spacieuse offre un véritable havre de paix pour les familles nombreuses. Avec ses 5 couchages confortables et son aménagement pensé pour le bien-être de tous, elle garantit un séjour mémorable en Normandie.',
        features: ['Télévision', 'WiFi gratuit', 'Salle de bain privative', 'Espace familial']
      }
    ],
    breakfast: {
      title: 'Petit déjeuner',
      description: 'Le petit déjeuner est le repas le plus important, avec notre buffet disposant d\'un large choix, vous trouverez tout ce qu\'il vous faut pour bien commencer la journée.',
      priceText: 'Prix du petit déjeuner : 9.50€ par personne'
    }
  },
  en: {
    pageTitle: 'Our Rooms',
    pricePrefix: 'Starting from',
    taxInfo: '*plus {taxe}€ tourist tax per person',
    rooms: [
      {
        id: 'single',
        title: 'Single Rooms',
        description: 'Perfect for solo travelers, our Single room offers a cozy and warm space with all modern comforts. Ideal for recharging after a day of discovery in Normandy.',
        features: ['TV', 'WiFi gratuit', 'Private bathroom']
      },
      {
        id: 'double',
        title: 'Double Rooms',
        description: 'Enjoy a romantic stay in our Double room, combining comfort and elegance. A perfect cocoon to rest after exploring the wonders of Normandy.',
        features: ['TV', 'Free WiFi', 'Private bathroom']
      },
      {
        id: 'design',
        title: 'Design Rooms',
        description: 'Three "Design" rooms, including one accessible for disabled guests, are available for more comfort and elegance. These rooms have received an architecture award from CAUE (Council of Architecture, Urban Planning and Environment).',
        pmrNote: '2 wheelchair accessible rooms available. Please specify when booking.',
        features: ['TV', 'Free WiFi', 'Private bathroom', 'Award-winning design', 'Accessibility']
      },
      {
        id: 'family4',
        title: 'Family Rooms (4 people)',
        description: 'Experience an unforgettable family stay in our spacious rooms that can accommodate up to 4 people. All the necessary comfort for each family member to feel at home.',
        features: ['TV', 'Free WiFi', 'Private bathroom', 'Family space']
      },
      {
        id: 'family5',
        title: 'Family Rooms (5 people)',
        description: 'Our most spacious family room offers a true haven of peace for large families. With its 5 comfortable beds and its layout designed for everyone\'s well-being, it guarantees a memorable stay in Normandy.',
        features: ['TV', 'Free WiFi', 'Private bathroom', 'Family space']
      }
    ],
    breakfast: {
      title: 'Breakfast',
      description: 'Breakfast is the most important meal, with our buffet offering a wide selection, you will find everything you need to start the day right.',
      priceText: 'Breakfast price: 9.50€ per person'
    }
  }
};

// Fonction utilitaire pour récupérer les textes des chambres en fonction de la langue
export const getRoomText = (lang, path) => {
  const keys = path.split('.');
  let result = roomTexts[lang];
  
  for (const key of keys) {
    if (result && result[key] !== undefined) {
      result = result[key];
    } else {
      return undefined;
    }
  }
  
  return result;
};

// Fonction pour obtenir une chambre spécifique par son ID
export const getRoomById = (lang, roomId) => {
  const rooms = roomTexts[lang]?.rooms || roomTexts.fr.rooms;
  return rooms.find(room => room.id === roomId);
};

// Exportations pour maintenir la compatibilité avec les composants existants
export const rooms = roomTexts.fr.rooms.map(room => ({
  id: room.id,
  title: room.title,
  description: room.description,
  price: room.id === 'single' ? 61 : 
         room.id === 'double' ? 71 : 
         room.id === 'design' ? 91 : 
         room.id === 'family4' ? 119 : 
         129,
  breakfast: 9.50,
  taxe: 1.90,
  image: `${room.id}.jpg`,
  features: room.features
}));

export const breakfast = {
  title: roomTexts.fr.breakfast.title,
  description: roomTexts.fr.breakfast.description,
  image: 'breakfast.jpg'
};
